






































































































import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { diffDeep, setErrorFromAxiosError } from '@/utils/helpers';
import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';
import formRulesMixin from '@/mixins/file-upload-rules';
import { getCurrencySymbol } from '@/utils/currency';

import {
  ContractItem,
  IContract,
  IContractItem,
  IContractItemData
} from '@/models';
import { SystemError } from '@/models/error/error';
import { ISystemError } from '@/models/error/error.types';

import { ALForm } from '@/common/component.types';
import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import DatePicker from '@/components/common/DatePicker.vue';

const baseMixins = mixins(authMixin, formRulesMixin);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'ContractItemFormDialog',

    components: {
      ALDialog,
      DatePicker,

      ErrorAlert
    },

    props: {
      contract: {
        type: Object as PropType<IContract>
      }
    },

    data() {
      return {
        dialog: false,
        loading: false,
        isEdit: false,
        isFormValid: false,

        contractItemData: {} as IContractItemData,

        error: null as ISystemError | null,

        requiredRule: [(v: string) => !!v || 'This field is required'],

        positiveNumberRequiredRule: [
          (v: number) => (!!v && v > 0) || 'Must be a number greater than 0'
        ]
      };
    },

    computed: {
      ...mapGetters({
        getContractItemById: 'contract/getContractItemById'
      })
    },

    methods: {
      getCurrencySymbol,

      ...mapActions({
        createContractItem: 'contract/createContractItem',
        updateContractItem: 'contract/updateContractItem'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open(contract?: IContractItem) {
        this.clearErrors();
        this.resetFormValidation();
        this.isEdit = !!contract;

        this.contractItemData = this.isEdit
          ? new ContractItem(contract!)
          : ({
              quantity: 0
            } as IContractItemData);

        this.dialog = true;
      },

      close() {
        this.dialog = false;
      },

      async save() {
        this.clearErrors();
        const valid = this.validateForm();

        if (valid) {
          let contractInstance: IContractItem | null = null;

          try {
            contractInstance = new ContractItem(this.contractItemData);
          } catch (error) {
            if (SystemError.isSystemError(error)) {
              this.error = error;
            }
          }

          if (contractInstance != null) {
            this.loading = true;

            const saveAction = this.isEdit
              ? this.updateContractItem
              : this.createContractItem;

            let payload = contractInstance;

            if (this.isEdit) {
              payload = diffDeep(
                contractInstance,
                this.getContractItemById(this.contract.id, contractInstance.id),
                true
              );
            }

            saveAction({ contractId: this.contract.id!, item: payload })
              .then(() => {
                this.close();
              })
              .catch(error => {
                this.error = setErrorFromAxiosError(error);
              })
              .finally(() => (this.loading = false));
          }
        }
      },

      clearErrors() {
        this.error = null;
      }
    }
  });
